export default __webpack_public_path__ + "static/media/Jin_HydropumpImpact.d2f83205.png";